// Copyright (c) 2021, DIALPAD INC., all rights reserved.

import React, {useState, useEffect} from 'react';
import {Link} from 'react-router-dom';
import {
    fetchFeedbackMessage,
    renderTitleByType,
    renderTitleIconByType,
    fetchCxLabels,
} from './utils';
import {get} from 'lodash';
import {CXAnswer} from './answer';
import {CXFeedback} from './feedback';
import {MdRemoveRedEye} from 'react-icons/md';
import {npsEnabled} from '@app/utils/dom';

interface MessageCxProps {
    allMessages: any[];
    message: any;
    messages: any;
    metricId: string;
    type: string;
}

// Creates the CX message conversation block.
export const MessageCX = (props: MessageCxProps) => {
    const {message: answerMessage, allMessages} = props;
    const metricId = get(answerMessage, 'body.metric_id');
    const parentId = get(answerMessage, 'parent_id');
    const type = get(answerMessage, 'body.aspect');

    const [feedbackMessage, setFeedbackMessage] = useState();
    const [labels, setLabels] = useState<any>();

    useEffect(() => {
        setFeedbackMessage(
            fetchFeedbackMessage(allMessages, metricId, parentId),
        );
        setLabels(fetchCxLabels(allMessages, metricId));
    }, [allMessages, metricId, type]);

    return (
        ((type && type === 'nps' && npsEnabled()) || type !== 'nps') && (
            <div className="console-activity-message-container console-activity-message is-cx-question console-activity-message--in console-activity--in">
                <div className="message-cx__header">
                    <span className="message-cx__icon">
                        {renderTitleIconByType(type)}
                    </span>
                    <span className="message-cx_title-container">
                        <span className="message-cx__title">
                            {renderTitleByType(type)}
                        </span>
                        <span className="message-cx__metric">{metricId}</span>
                    </span>
                </div>
                <div className="message-cx__body">
                    <div className="message-cx__container">
                        <CXAnswer message={{...answerMessage, ...labels}} />
                    </div>
                    {feedbackMessage && (
                        <CXFeedback
                            message={feedbackMessage}
                            answerMessage={answerMessage}
                        />
                    )}
                </div>
                <div className="message-cx__footer">
                    <Link
                        to="/activity/feedback"
                        className="message-cx__feedback-all"
                    >
                        <MdRemoveRedEye size={14} />
                        <span>SEE ALL FEEDBACK MESSAGES</span>
                    </Link>
                </div>
            </div>
        )
    );
};
